module.exports = __webpack_public_path__ + "assets/img/testi4.71fc4064.jpg";